module.exports = "<template>\n  <vue-tree></vue-tree>\n</template>\n\n<script>\nexport default {\n  components: {\n    VueTree\n  }\n}\n</script>\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./app/components/examples/Simple.vue.raw
// module id = gL8S
// module chunks = 1